import { css } from 'styled-components';
import { themeGet } from '../v2/foundation/theme/themeGet/get.js';
import { pxToRem, padding } from '../v2/foundation/spacing/utils.js';
import { fontSize } from './typography/fontSize.js';
import { interactiveTransition } from '../v2/foundation/theme/utils.js';

var inputHoverStyles = css(["background-color:", ";border-color:", ";color:", ";border-width:", ";border-style:solid;box-shadow:0 0 0 ", " ", ";"], themeGet('colors.gray.0'), function (props) {
  return props.$invalid ? themeGet('colors.red.300') : themeGet('colors.primary.200');
}, themeGet('colors.gray.800'), pxToRem(1), pxToRem(3), function (props) {
  return props.$invalid ? themeGet('colors.red.200') : themeGet('colors.primary.50');
});
var inputFocusStyles = css(["outline:none;background-color:", ";border-color:", ";color:", ";box-shadow:0 0 0 ", " ", ";"], themeGet('colors.gray.0'), function (props) {
  return props.$invalid ? themeGet('colors.red.500') : themeGet('colors.primary.400');
}, themeGet('colors.gray.800'), pxToRem(3), function (props) {
  return props.$invalid ? themeGet('colors.red.200') : themeGet('colors.primary.50');
});
var inputDisabledStyles = css(["background-color:", ";border:", " solid ", ";color:", ";"], themeGet('colors.gray.50'), pxToRem(1), themeGet('colors.gray.200'), themeGet('colors.gray.300'));
var inputBaseStyles = css(["", ";", ";", ";border-radius:", ";display:block;height:", ";background-color:", ";border:", " solid ", ";color:", ";font-family:inherit;appearance:none;"], fontSize('small'), padding(2, 0), interactiveTransition, pxToRem(6), pxToRem(40), themeGet('colors.gray.0'), pxToRem(1), function (props) {
  return props.$invalid ? themeGet('colors.red.500') : themeGet('colors.gray.200');
}, themeGet('colors.gray.700'));
var inputAppearance = function inputAppearance(_ref) {
  var _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? '' : _ref$appearance;
  switch (appearance) {
    case 'highlight':
      return css(["& > input,& > textarea{background-color:", ";border-color:", ";color:", ";}& svg{fill:", ";}"], themeGet('colors.blue.50'), themeGet('colors.blue.300'), themeGet('colors.gray.800'), themeGet('colors.blue.500'));
    default:
      return css([""]);
  }
};
var inputStyles = css(["", ";&:hover{", ";}", ";&:focus-visible{", ";}&:disabled{", ";}::placeholder{color:", ";opacity:1;}:-ms-input-placeholder{color:", ";}::-ms-input-placeholder{color:", ";}"], inputBaseStyles, inputHoverStyles, function (props) {
  return props.$isFocused && inputFocusStyles;
}, inputFocusStyles, inputDisabledStyles, themeGet('colors.gray.700'), themeGet('colors.gray.700'), themeGet('colors.gray.700'));

export { inputAppearance, inputBaseStyles, inputDisabledStyles, inputFocusStyles, inputHoverStyles, inputStyles };
